import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getPersonCustomerSatisfactionData = (personId, state, setState) => {
  if (personId) {
    const api = initApi(API_NAMES.PERSON, state, setState);
    const personIdForUrl = encodeURIComponent(personId);
    const url = `/person/${personIdForUrl}/CustomerSatisfaction`;

    return api?.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const PersonCustomerSatisfactionData = {
  getPersonCustomerSatisfactionData,
};

export default PersonCustomerSatisfactionData;